import { useState } from 'react';
import { DialogContent } from '@material-ui/core';
import PropTypes from 'prop-types';

import { CustomDialog } from 'src/components/CustomDialog';
import { FieldInput } from 'src/components/FieldInput';

import { useStyles } from './useStyles';

export const ExportAssetNamePopup = ({ open, title, onSubmit, onCancel }) => {
  const styles = useStyles();

  const [value, setValue] = useState('');

  const handleSubmit = () => {
    onSubmit(value || '');
  };

  return (
    <CustomDialog
      className={styles.root}
      open={open}
      onClose={onCancel}
      title={title}
      onSubmit={handleSubmit}
      submitLabel="Export"
      onCancel={onCancel}
      cancelLabel="Close"
    >
      <DialogContent>
        <FieldInput
          className={styles.input}
          label="Asset name"
          value={value}
          onChange={(event) => {
            setValue(event.target.value);
          }}
          autoFocus
        />
      </DialogContent>
    </CustomDialog>
  );
};

ExportAssetNamePopup.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

ExportAssetNamePopup.defaultProps = {
  open: false,
};
